








































































import { Vue, Prop, Component } from "vue-property-decorator";
import { CourseListener as ICourseListener } from "@/api/models/course-listener";
import CustomTableItem from "@/components/form/CustomTableItem.vue";
import CustomTableCol from "@/components/form/CustomTableCol.vue";
import { isAllowEditDates } from "@/plugins/modules-detect";
import CustomDatepicker from "@/components/form/CustomDatepicker.vue";
import CustomButton from "@/components/form/CustomButton.vue";
import { AxiosError } from "axios";
import { ErrorResponse as IErrorResponse } from "@/api/models/error-response";
import { ValidationErrorResponse as IValidationErrorResponse } from "@/api/models/validation-error-response";
import api from "@/getinfo-api";

@Component({
  components: {
    CustomButton,
    CustomDatepicker,
    CustomTableCol,
    CustomTableItem
  }
})
export default class ListenerProgressPreviewItem extends Vue {
  @Prop() listener!: ICourseListener;
  passedAt?: Date = this.listener.passedAt;
  isShowPassedAt: boolean = false;

  get statusClasses() {
    let formatted: string = "";
    if (this.listener.success === true) formatted = "passed";
    if (this.listener.success === false) formatted = "not_passed";
    if (!this.listener.hasOwnProperty("success")) formatted = "waiting";
    return formatted;
  }

  get formatSuccessStatus() {
    let formatted: string = "";
    if (this.listener.success === true)
      formatted = this.$tc(this.$translate.Successful);
    if (this.listener.success === false)
      formatted = this.$tc(this.$translate.Unsuccessful);
    if (!this.listener.hasOwnProperty("success"))
      formatted = this.$tc(this.$translate.Training);
    return formatted;
  }

  get isAllowEditDates() {
    return isAllowEditDates();
  }

  savePassedAt() {
    if (this.passedAt)
      api.CourseApi.listenerEditPassedAt(
        this.passedAt,
        this.listener.course.id,
        this.listener.id
      )
        .then(() => {
          this.$emit("datesChanged");
        })
        .catch((err: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
          this.$store.dispatch("errorException", {
            vm: this,
            error: err.response
          });
        });
  }
}
